import { useState } from "react";

export const useMapState = <K, V>(initialState: Map<K, V> = new Map()) => {
  const [map, setMap] = useState(initialState);
  const get = (key: K) => map.get(key);
  const set = (key: K, value: V) => {
    setMap((prevState) => {
      const newState = new Map(prevState);
      newState.set(key, value);
      return newState;
    });
  };
  const has = (key: K) => map.has(key);
  const getFullMap = () => map;
  return { get, set, has, getFullMap };
};
